export default __webpack_public_path__ + "static/media/maybe.32a41e49.svg";